var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form',{staticClass:"ui form",on:{"submit":function($event){$event.preventDefault();return _vm.submit()}}},[_c('navigation'),_c('update-form',{ref:"form",attrs:{"addressModel":_vm.addressModel,"companyModels":_vm.companyModels,"countryModels":_vm.countryModels,"stateModels":_vm.stateModels}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }